import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { MdInfoOutline, MdUpload, MdArrowUpward, MdArrowDownward, MdSync } from 'react-icons/md';
import { SiteEmpresaDto, SiteVeiculoDto, obterUrlImagemPreview, sincronizarVeiculos, uploadFotoVeiculo } from '../../services/meuSiteService';

const AZUL = '#1F467E';
const BORDA = '#e2e8f0';
const FUNDO = '#f5f7fa';

const ConfigCard = styled.div`
    background: #fff;
    border: 1px solid ${BORDA};
    border-radius: 8px;
    padding: 18px 20px;
    margin-bottom: 20px;
`;

const ToggleRow = styled.label`
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    color: #1e293b;
    user-select: none;
    margin-bottom: 8px;
`;

const ToggleRowInput = styled.input`
    width: 36px;
    height: 20px;
    cursor: pointer;
    accent-color: ${AZUL};
`;

const AjudaTexto = styled.p`
    margin: 0;
    font-size: 13px;
    color: #64748b;
    line-height: 1.5;
`;

const TopBar = styled.div`
    position: sticky;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    padding: 8px 0 12px;
    margin-bottom: 16px;
    background: ${FUNDO};
`;

const SyncBlock = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
`;

const SyncBtn = styled.button`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 9px 16px;
    background: ${AZUL};
    color: #fff;
    border: none;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    &:hover { background: #163560; }
    &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

const SyncHint = styled.span`
    font-size: 12px;
    color: #64748b;
    max-width: 340px;
`;

const SaveBtn = styled.button`
    padding: 9px 20px;
    background: ${AZUL};
    color: #fff;
    border: none;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    &:hover { background: #163560; }
    &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

const VeiculoCard = styled.div`
    background: #fff;
    border: 1px solid ${BORDA};
    border-radius: 8px;
    padding: 14px 18px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
`;

const FotoContainer = styled.div`
    position: relative;
    flex-shrink: 0;
`;

const Foto = styled.img`
    width: 72px;
    height: 54px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid ${BORDA};
    background: ${FUNDO};
    display: block;
`;

const FotoPlaceholder = styled.div`
    width: 72px;
    height: 54px;
    border-radius: 6px;
    border: 1px dashed #cbd5e1;
    background: ${FUNDO};
    display: flex;
    align-items: center;
    justify-content: center;
    color: #94a3b8;
    font-size: 11px;
`;

const FotoUploadOverlay = styled.label`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0,0,0,0.4);
    border-radius: 6px;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.15s;
    color: #fff;
    ${FotoContainer}:hover & { opacity: 1; }
`;

const Info = styled.div`
    flex: 1;
    min-width: 180px;
`;

const VeiculoNome = styled.div`
    font-size: 13px;
    font-weight: 600;
    color: #1e293b;
`;

const VeiculoSub = styled.div`
    font-size: 12px;
    color: #64748b;
    margin-top: 2px;
`;

const Controls = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    flex-wrap: wrap;
`;

const Toggle = styled.label`
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #374151;
    cursor: pointer;
    white-space: nowrap;
`;

const ToggleInput = styled.input`
    width: 34px;
    height: 18px;
    cursor: pointer;
    accent-color: ${AZUL};
`;

const PriceGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
`;

const PriceLabel = styled.span`
    font-size: 11px;
    color: #94a3b8;
    white-space: nowrap;
`;

const PriceInput = styled.input`
    width: 80px;
    height: 32px;
    border: 1px solid ${BORDA};
    border-radius: 6px;
    padding: 0 8px;
    font-size: 12px;
    color: #374151;
    &:focus { outline: 2px solid ${AZUL}; }
`;

const OrderBtns = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

const OrderBtn = styled.button`
    background: none;
    border: 1px solid ${BORDA};
    border-radius: 4px;
    padding: 2px 4px;
    cursor: pointer;
    color: #64748b;
    display: flex;
    align-items: center;
    &:hover { background: ${FUNDO}; }
    &:disabled { opacity: 0.3; cursor: not-allowed; }
`;

const Badge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: #fef3c7;
    color: #92400e;
    border-radius: 4px;
    padding: 2px 7px;
    font-size: 11px;
    font-weight: 500;
`;

const Tooltip = styled.span`
    position: relative;
    display: inline-flex;
    align-items: center;
    cursor: help;

    &:hover::after {
        content: attr(data-tip);
        position: absolute;
        bottom: 120%;
        left: 50%;
        transform: translateX(-50%);
        background: #1e293b;
        color: #fff;
        font-size: 11px;
        padding: 5px 9px;
        border-radius: 5px;
        white-space: nowrap;
        max-width: 260px;
        white-space: normal;
        text-align: center;
        z-index: 10;
    }
`;

interface Props {
    site: SiteEmpresaDto;
    veiculos: SiteVeiculoDto[];
    onVeiculosChange: (v: SiteVeiculoDto[]) => void;
    onSave: () => Promise<void>;
    saving: boolean;
    onExibeVeiculosIndisponiveisChange: (valor: boolean) => Promise<void>;
}

function extrairMensagem(err: any): string {
    return err?.response?.data?.mensagem
        || err?.response?.data?.Mensagem
        || 'Erro ao realizar operação.';
}

export function AbaVeiculos({ site, veiculos, onVeiculosChange, onSave, saving, onExibeVeiculosIndisponiveisChange }: Props) {
    const [syncing, setSyncing] = useState(false);
    const [uploadingId, setUploadingId] = useState<string | null>(null);
    const [salvandoIndisponiveis, setSalvandoIndisponiveis] = useState(false);
    const fileInputRefs = useRef<Record<string, HTMLInputElement | null>>({});

    const alternarIndisponiveis = async (valor: boolean) => {
        setSalvandoIndisponiveis(true);
        try {
            await onExibeVeiculosIndisponiveisChange(valor);
        } finally {
            setSalvandoIndisponiveis(false);
        }
    };

    const handleSincronizar = async () => {
        setSyncing(true);
        try {
            const res = await sincronizarVeiculos();
            onVeiculosChange(res.data);
            toast.success(`${res.data.length} veículo(s) sincronizado(s).`);
        } catch (err) {
            toast.error(extrairMensagem(err));
        } finally {
            setSyncing(false);
        }
    };

    const update = (id: string, patch: Partial<SiteVeiculoDto>) => {
        onVeiculosChange(veiculos.map(v => v.idVeiculo === id ? { ...v, ...patch } : v));
    };

    const moverCima = (idx: number) => {
        if (idx === 0) return;
        const next = [...veiculos];
        [next[idx - 1], next[idx]] = [next[idx], next[idx - 1]];
        onVeiculosChange(next.map((v, i) => ({ ...v, ordem: i })));
    };

    const moverBaixo = (idx: number) => {
        if (idx === veiculos.length - 1) return;
        const next = [...veiculos];
        [next[idx + 1], next[idx]] = [next[idx], next[idx + 1]];
        onVeiculosChange(next.map((v, i) => ({ ...v, ordem: i })));
    };

    const handleFotoUpload = async (idVeiculo: string, file: File) => {
        setUploadingId(idVeiculo);
        try {
            const res = await uploadFotoVeiculo(idVeiculo, file);
            update(idVeiculo, { fotoOverrideArquivoId: res.data.arquivoId });
            toast.success('Foto atualizada.');
        } catch (err) {
            toast.error(extrairMensagem(err));
        } finally {
            setUploadingId(null);
            const inp = fileInputRefs.current[idVeiculo];
            if (inp) inp.value = '';
        }
    };

    const [fotoUrls, setFotoUrls] = useState<Record<string, string>>({});

    useEffect(() => {
        let ativo = true;
        const ids = Array.from(new Set(
            veiculos
                .map(v => v.fotoOverrideArquivoId || v.fotoArquivoId)
                .filter((id): id is string => !!id)
        )).filter(id => !(id in fotoUrls));
        if (ids.length === 0) return;
        Promise.all(ids.map(async id => [id, await obterUrlImagemPreview(id)] as const)).then(pares => {
            if (!ativo) return;
            setFotoUrls(prev => {
                const next = { ...prev };
                for (const [id, url] of pares) {
                    if (url) next[id] = url;
                }
                return next;
            });
        });
        return () => { ativo = false; };
    }, [veiculos, fotoUrls]);

    const fotoUrl = (v: SiteVeiculoDto): string | null => {
        const id = v.fotoOverrideArquivoId || v.fotoArquivoId;
        return id ? fotoUrls[id] || null : null;
    };

    return (
        <div>
            <ConfigCard>
                <ToggleRow>
                    <ToggleRowInput
                        type="checkbox"
                        checked={site.exibeVeiculosIndisponiveis}
                        disabled={salvandoIndisponiveis}
                        onChange={e => alternarIndisponiveis(e.target.checked)}
                    />
                    Exibir veículos alugados no site como indisponíveis
                </ToggleRow>
                <AjudaTexto>
                    Quando ativo, veículos com locação em andamento continuam na vitrine com o selo Indisponível e um botão Consultar, que abre o WhatsApp para o visitante registrar interesse.
                </AjudaTexto>
            </ConfigCard>

            <TopBar>
                <SyncBlock>
                    <SyncBtn onClick={handleSincronizar} disabled={syncing}>
                        <MdSync size={16} />
                        {syncing ? 'Sincronizando...' : 'Sincronizar com o sistema'}
                    </SyncBtn>
                    <SyncHint>
                        Traz os veículos da sua frota, incluindo os alugados, e sugere preços com base no último contrato de cada um. A sincronização também roda automaticamente todo dia de madrugada.
                    </SyncHint>
                </SyncBlock>
                <SaveBtn onClick={onSave} disabled={saving}>
                    {saving ? 'Salvando...' : 'Salvar veículos'}
                </SaveBtn>
            </TopBar>

            {veiculos.length === 0 && (
                <div style={{ color: '#64748b', fontSize: 13, textAlign: 'center', padding: '32px 0' }}>
                    Nenhum veículo. Use "Sincronizar com o sistema" para importar os veículos da sua frota.
                </div>
            )}

            {veiculos.map((v, idx) => {
                const url = fotoUrl(v);
                return (
                    <VeiculoCard key={v.idVeiculo}>
                        <OrderBtns>
                            <OrderBtn type="button" onClick={() => moverCima(idx)} disabled={idx === 0}>
                                <MdArrowUpward size={14} />
                            </OrderBtn>
                            <OrderBtn type="button" onClick={() => moverBaixo(idx)} disabled={idx === veiculos.length - 1}>
                                <MdArrowDownward size={14} />
                            </OrderBtn>
                        </OrderBtns>

                        <FotoContainer>
                            {url ? (
                                <Foto src={url} alt={`${v.marca} ${v.modelo}`} />
                            ) : (
                                <FotoPlaceholder>Sem foto</FotoPlaceholder>
                            )}
                            <FotoUploadOverlay>
                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    ref={el => { fileInputRefs.current[v.idVeiculo] = el; }}
                                    onChange={e => {
                                        const file = e.target.files?.[0];
                                        if (file) handleFotoUpload(v.idVeiculo, file);
                                    }}
                                />
                                {uploadingId === v.idVeiculo ? '...' : <MdUpload size={20} />}
                            </FotoUploadOverlay>
                        </FotoContainer>

                        <Info>
                            <VeiculoNome>{v.marca} {v.modelo}</VeiculoNome>
                            <VeiculoSub>{v.ano}{v.cor ? ` · ${v.cor}` : ''}</VeiculoSub>
                            {v.precoAproximadoQuinzenal && (
                                <Badge>
                                    <Tooltip
                                        data-tip="Sugestão aproximada a partir de contrato quinzenal (valor dividido por 2). Confira antes de publicar."
                                        title="Sugestão aproximada a partir de contrato quinzenal (valor dividido por 2). Confira antes de publicar."
                                    >
                                        <MdInfoOutline size={13} />
                                    </Tooltip>
                                    Preço aproximado
                                </Badge>
                            )}
                        </Info>

                        <Controls>
                            <Toggle>
                                <ToggleInput
                                    type="checkbox"
                                    checked={v.visivel}
                                    onChange={e => update(v.idVeiculo, { visivel: e.target.checked })}
                                />
                                Visível
                            </Toggle>

                            <PriceGroup>
                                <PriceLabel>Diária R$</PriceLabel>
                                <PriceInput
                                    type="number"
                                    min={0}
                                    step={0.01}
                                    value={v.precoDiaria ?? ''}
                                    placeholder=""
                                    onChange={e => update(v.idVeiculo, { precoDiaria: e.target.value === '' ? null : Number(e.target.value) })}
                                />
                                <PriceLabel>Semanal R$</PriceLabel>
                                <PriceInput
                                    type="number"
                                    min={0}
                                    step={0.01}
                                    value={v.precoSemanal ?? ''}
                                    placeholder=""
                                    onChange={e => update(v.idVeiculo, { precoSemanal: e.target.value === '' ? null : Number(e.target.value) })}
                                />
                                <PriceLabel>Mensal R$</PriceLabel>
                                <PriceInput
                                    type="number"
                                    min={0}
                                    step={0.01}
                                    value={v.precoMensal ?? ''}
                                    placeholder=""
                                    onChange={e => update(v.idVeiculo, { precoMensal: e.target.value === '' ? null : Number(e.target.value) })}
                                />
                            </PriceGroup>
                        </Controls>
                    </VeiculoCard>
                );
            })}
        </div>
    );
}
